<template>
    <ai-grid-edit
        ref='gridRef'
        :meta='gridMeta'
        :args='gridArgs'
        :to-remove-toolbar-items-names='removeGridToolbarBtns'
    ></ai-grid-edit>
</template>
<script>
export default {
    name: 'ds-otop-norm-view',
};
</script>
<script setup>
import { computed, onMounted, ref } from 'vue';
import { getCookie } from '@/utils/cookies';
import AiGridEdit from '@/components/ai-grid-edit/ai-grid-edit.vue';

const gridRef = ref(null);

const commonArgs = {
    depId: +getCookie('dep'),
};

const gridArgs = computed(() => {
    return {
        select: {
            select_args:{...commonArgs}
        },
        save: {
            update_args: {...commonArgs},
            insert_args: {...commonArgs},
            delete_args: {...commonArgs},
        },
    }
});

onMounted(async () => {
    await gridRef.value?.setDataSource();
});

const removeGridToolbarBtns = [ 'edit', 'choice', 'show-column-chooser', 'searchPanel', 'copy', 'export'];
const gridMeta = {

    keyExpr: 'kod_norm',
    columns: [
        {
            name: 'kod_norm',
            caption: 'Код',
            dataField: 'kod_norm',
            allowEditing: false,
            dataType: 'number',
            width: 100,
            index: 1,
            visible: false,
        },
        {
            name: 'series',
            caption: 'Группа домов',
            dataField: 'series',
            allowEditing: true,
            width: '40%',
            index: 2,
            visible: true,
        },
        {
            name: 'norm',
            caption: 'Норматив на отопление (Гкал/м.кв.)',
            dataField: 'norm',
            allowEditing: true,
            dataType: 'number',
            width: '20%',
            index: 3,
            visible: true,
        },
        {
            name: 'norm_odn',
            caption: 'Норматив на ОДН отопление (Гкал/м.кв.)',
            dataField: 'norm_odn',
            allowEditing: true,
            dataType: 'number',
            width: '20%',
            index: 4,
            visible: true,
        },
        {
            name: 'norm_odn_gvs',
            caption: 'Норматив на ОДН ГВС (м.куб./м.кв.)',
            dataField: 'norm_odn_gvs',
            allowEditing: true,
            dataType: 'number',
            width: '20%',
            index: 5,
            visible: true,
        }
    ],
    api: {
        select: 'tep-nsi./tep-nsi/ds-otop-norm/select/get',
        save: 'tep-nsi./tep-nsi/ds-otop-norm/save/set',
    },
    viewId: 'ds-otop-norm-view',
    isFilterPanelVisible: false,
}
</script>
<style scoped>

</style>
